import type { IFontInfo } from "./IFontInfo"
/**
 * 内置字体表：只在当前环境真的装了这个家族时才会被 Gaia 登记（见 Gaia.checkFont）
 *
 * Built-in font list: Gaia only registers the families the current environment really has
 * (see Gaia.checkFont).
 */
export const BUILT_IN_FONTS: IFontInfo[] = [
  { family: "SimSun", name: "宋体", desc: "宋体" },
  { family: "SimHei", name: "黑体", desc: "黑体" },
  { family: "Microsoft Yahei", name: "微软雅黑", desc: "微软雅黑" },
  { family: "Microsoft JhengHei", name: "微软正黑体", desc: "微软正黑体" },
  { family: "KaiTi", name: "楷体", desc: "楷体" },
  { family: "NSimSun", name: "新宋体", desc: "新宋体" },
  { family: "FangSong", name: "仿宋", desc: "仿宋" },
  { family: "STKaiti", name: "华文楷体", desc: "华文楷体" },
  { family: "STSong", name: "华文宋体", desc: "华文宋体" },
  { family: "STFangsong", name: "华文仿宋", desc: "华文仿宋" },
  { family: "STZhongsong", name: "华文中宋", desc: "华文中宋" },
  { family: "STHupo", name: "华文琥珀", desc: "华文琥珀" },
  { family: "STXinwei", name: "华文新魏", desc: "华文新魏" },
  { family: "STLiti", name: "华文隶书", desc: "华文隶书" },
  { family: "STXingkai", name: "华文行楷", desc: "华文行楷" },
  { family: "YouYuan", name: "幼圆", desc: "幼圆" },
  { family: "LiSu", name: "隶书", desc: "隶书" },
  { family: "STXihei", name: "华文细黑", desc: "华文细黑" },
  { family: "STCaiyun", name: "华文彩云", desc: "华文彩云" },
  { family: "FZShuTi", name: "方正舒体", desc: "方正舒体" },
  { family: "FZYaoti", name: "方正姚体", desc: "方正姚体" },
]